@use '@design/design-tokens/typography/typography' as *;

.styledModal {
  [data-modal-container] {
    max-width: 80%;
    width: var(--actions-modal-width, 540px);
  }

  [data-alert-root] {
    width: 100%;
    padding: 8px 16px;
    align-items: center;
  }
}

.contentContainer {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @include typography-v2-body-base;
}
